import ClearIcon from "@mui/icons-material/Clear";

const ActionAlert = ({
  className,
  msg,
  btnText,
  onBtnClickHandler,
  onCloseHandler,
}) => (
  <div className={`${className} action`}>
    <button className="close-btn" onClick={onCloseHandler}>
      <ClearIcon fontSize="16px" />
    </button>
    <div className="right-container">
      {msg}
      {btnText && onBtnClickHandler && (
        <button className="action-btn" onClick={onBtnClickHandler}>
          {btnText}
        </button>
      )}
    </div>
  </div>
);

export default ActionAlert;
